import React from "react";
import {
  Grid,
  Typography,
  Link,
  makeStyles,
  Theme,
  createStyles,
  IconButton,
} from "@material-ui/core";
import { IArticle } from "../../core/redux/dataMap/article";
import { ReactComponent as ReactIcon } from "../../assets/imgs/icons/react.svg";
import useLanguage from "../../hooks/useLanguage";

interface ISnippetListProps {
  article: IArticle;
  closePaper(): void;
}

export const SnippetList: React.FC<ISnippetListProps> = ({
  article,
  closePaper,
}) => {
  const { language } = useLanguage();
  const { translate } = language;
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Grid container justify="flex-start">
        <Grid item>
          <IconButton onClick={closePaper}>
            <ReactIcon />
          </IconButton>
        </Grid>
      </Grid>
      <div className={classes.snippetContainer}>
        {article.snippets.map((snippet, index) => (
          <Grid container className={classes.snippet} key={index}>
            <Grid item>
              <Typography className={classes.snippetText}>
                {snippet.text}
              </Typography>
            </Grid>
            <Grid item md={12}>
              <Grid container>
                <Grid item className={classes.sourceText} md={10} lg={10}>
                  <Link
                    href={snippet.source.url || snippet.reportUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    color="inherit"
                  >
                    {snippet.source.name || "Quelle"}
                  </Link>
                </Grid>
                {/* <Grid item className={classes.removeIcon} md={2} lg={2}>
                  <i className="fa fa-close" aria-hidden="true"></i>
                </Grid> */}
              </Grid>
            </Grid>
          </Grid>
        ))}
        <Typography
          variant="caption"
          display="block"
          gutterBottom
          className={classes.defaultSnipet}
        >
          {translate.empty_snippet}
        </Typography>
      </div>
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "300px",
      height: "100%",
      backgroundColor: "whitesmoke",
      padding: "25px",
    },
    snippetContainer: {
      height: "calc(100% - 50px)",
      overflow: "auto",
    },
    snippet: {
      borderBottom: "1px solid rgba(152, 152, 152, 0.5)",
      width: "inherit",
      padding: "10px 5px",
      "&:hover": {
        /* border: 1px solid rgba(234, 234, 234, 0.5), */
      },
      "&:active": {
        border: "none",
      },
    },
    snippetText: {
      fontFamily: "Roboto",
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "12px",
      lineHeight: "14px",
      textAlign: "justify",
      color: "#5F5F5F",
    },
    sourceText: {
      fontFamily: "Roboto",
      fontStyle: "normal",
      fontWeight: "bold",
      fontSize: "10px",
      lineHeight: "12px",
      color: "#5F5F5F",
      padding: "5px 0px",
      textAlign: "left",

      "& a": {
        textDecoration: "none",
        color: "#5F5F5F",
      },
    },
    removeIcon: {
      color: "#A7A7A7",
      fontSize: "10pt",
    },
    defaultSnipet: {
      marginTop: "10px",
      textAlign: "justify",
      fontSize: "12px",
    },
  })
);
